import './ajaxWrapper.js';
import 'string.prototype.startswith';
import pack from '../package.json';
export { default as Base64 } from './base64.js';
export { default as BrowserDetection } from './browserDetection.js';
export { default as ConfigService } from './configurationService.js';
export { default as dateFormatter } from './dateFormatter.js';
import evnts from './event';
export const events = evnts;
export { default as nuskin } from './namespace.js';
export { default as init } from './init.js';
export { default as cookieUtil } from './cookieUtil.js';
import u from './nuskin.util.js';
u.version = pack.version;
export var util = u;
export { Application } from './application.js';
export { default as mktRegionMapping } from './regionMapping.js';
export { default as getMomentLocale } from './preferredLocaleMoment.js';
export { default as RunConfigService } from './runConfigService.js';
export { default as smoothScroll } from './smoothScroll.js';
export * from './stickyHeader.js';
export { default as StickyHeaderStack } from './stickyHeader.js';
export { default as storage } from './storage.js';
export { default as StringService } from './stringService.js';
export { default as TdcStrings } from './tdcStrings.js';
export { default as AgelocService } from './agelocService.js';
export { default as PreferencesCookieService } from './preferencesCookieService.js';
export { default as Preferences } from './preferences.js';
export { default as moment } from 'moment';
export { default as LocalStorageUtil } from './localStorageUtil.js';
export { default as PersonalOfferStorageService } from './personalOfferStorageService.js';
export { default as SponsorStorageService } from './sponsorStorageService.js';
export { default as StoreFrontSponsorStorageService } from './storeFrontSponsorService.js';
export { default as GoogleMapsAPILoader } from './googleMapsAPILoader';
export { default as NUSAnalytics } from './nusAnalytics.js';
export { default as WaitingRoomService } from './waitingRoomService.js';
export { default as GeoIPMarketRedirect } from './geoipmarketredirect.js';
export { default as GeoIPMarketRedirectV2 } from './geoipmarketredirectv2.js';
export { default as MarketSiteRegions } from './MarketSiteRegions.js';
export { default as MarketSiteRegionsV2 } from './MarketSiteRegionsv2.js';
export { default as SearchLocalStorageService } from './SearchLocalStorageService.js';
export { default as SearchSessionStorageService } from './SearchSessionStorageService.js';
export { default as SocialMediaShare } from './SocialMediaShare.js';
export { default as ShortenURL } from './ShortenURL.js';
export { default as TranslationsUtil } from './translationUtil.js';
export { default as SearchBarAdapter } from './nsSearchBarAdapter';
export { default as DowntimeService } from './downtimeService.js';
export { default as UrlService } from './urlService.js';
export { default as TranslationService } from './translationService.js';
export { default as SitesLocalStorageService } from './sitesLocalStorageService.js';
export { default as SitesSessionStorageService } from './sitesSessionStorageService.js';
export { default as ImageService } from './imageURLStringBuilder.js';
export { default as BreadcrumbUtil } from './BreadcrumbUtil.js';
export { default as InviteLinkService } from './invite-link-service.js';
export { default as InviteService } from './InviteService.js';
export { default as ShoppingContext } from './shoppingContext.js';
export { default as Validate } from './validate.js';
export { default as DirUtil } from './dirUtil.js';
export { default as contentstackService } from './contentstack/contentstack.js';
export { default as equinoxLocalStorage } from './local-storage/equinox.js';
export * from './errors';

// Load in the content stack configMaps that are needed in the code for ns-util
import { getConfiguration } from '@nuskin/configuration-sdk';
const runConfigCallback = (runConfig) => {
    if (runConfig && typeof runConfig.clientId === 'string') {
        evnts.unsubscribe(evnts.global.RUN_CONFIG_CHANGED, runConfigCallback);
        getConfiguration(['Signup', 'Url', 'Storefront']).then(() => console.log('ns-util config loaded'));
    }
}


evnts.getValue(evnts.global.RUN_CONFIG_CHANGED, runConfigCallback, true);